"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function UserRightsControls() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const faqItems = [{
    id: "item-1",
    question: "What personal data do you collect?",
    answer: "We collect only the information necessary to provide our services, including your name, email address, and usage data. All data collection is transparent and complies with GDPR regulations."
  }, {
    id: "item-2",
    question: "How can I access my data?",
    answer: "You have the right to request a copy of all personal data we hold about you. Simply contact our support team, and we will provide a comprehensive data export within 30 days."
  }, {
    id: "item-3",
    question: "Can I delete my account and data?",
    answer: "Yes, you can request complete deletion of your account and all associated data at any time. This process is irreversible and will be completed within 30 days of your request."
  }, {
    id: "item-4",
    question: "How do you protect my information?",
    answer: "We use industry-standard encryption, secure servers, and regular security audits to protect your data. Our team follows strict data protection protocols and privacy best practices."
  }, {
    id: "item-5",
    question: "Who has access to my data?",
    answer: "Your data is accessible only to authorized personnel who need it to provide services. We never sell your information to third parties and only share data with trusted partners when necessary for service delivery."
  }, {
    id: "item-6",
    question: "How can I update my privacy preferences?",
    answer: "You can manage your privacy settings anytime through your account dashboard. We provide granular controls over data collection, marketing communications, and third-party integrations."
  }];
  return <section id="user-rights-controls" ref={ref} className={`bg-background py-16 md:py-24 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-foreground mb-4">User Rights & Controls</h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Your privacy matters. Learn how you can access, manage, and protect
            your personal information with complete transparency and control.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqItems.map((item, i) => <AccordionItem key={item.id} value={item.id} data-index={i} className="bg-surface border border-border rounded-[var(--radius-sm)] px-6 hover:shadow-[0_6px_18px_rgba(0,0,0,0.08)] hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">
              <AccordionTrigger className="text-foreground hover:text-primary font-semibold text-left py-5 [&>svg]:text-muted-foreground [&[data-state=open]>svg]:text-primary [&[data-state=open]>svg]:transition-colors">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}